import { render } from "./App.vue?vue&type=template&id=3660beae"
const script = {}

import "@/assets/bootstrap.min.css?vue&type=style&index=0&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__